// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    --width: 32px;
    --height: 32px;
    display: none;
    /*border: 1px solid red;*/
    width: var(--width);
    height: var(--height);
    /*cursor: pointer;*/
    /*position: relative;*/
}


@media (max-width: 940px) {
    :host {
        display: inline-block;
        /*background: red;*/
        /*width: 26px;*/
        margin-left: var(--custom-spacing-30);
        /*margin-right: var(--spacing-15);*/
        margin-right: 0;
    }

    /*button {*/
    /*    border: 1px solid blue;*/
    /*}*/

}

/*================================================================================*/
/*================================================================================*/

button {
    width: var(--width);
    height: 100%;
    position: relative;
    border: none;
    background: none;
}

.toggler{
    /* ALWAYS KEEPING THE TOGGLER OR THE CHECKBOX ON TOP OF EVERYTHING :  */
    z-index:2;
    height: var(--height);
    width: var(--width);
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    opacity: 0;
}

.hamburger{
    position: absolute;

    top: 0;
    left: -4px;
    height: var(--height);
    width: var(--width);
    /* FOR DISPLAYING EVERY ELEMENT IN THE CENTER : */
    display: flex;
    align-items: center;
    justify-content: center;
}

/* CREATING THE MIDDLE LINE OF THE HAMBURGER : */
.hamburger > div{
    position: relative;
    top: 0;
    left: 4px;
    background: var(--text-default);
    height: 2px;
    width: var(--width);
    transition: all  0.2s ease;
}

/* CREATING THE TOP AND BOTTOM LINES :
TOP AT -10PX ABOVE THE MIDDLE ONE AND BOTTOM ONE IS 10PX BELOW THE MIDDLE: */

.hamburger > div::before,
.hamburger > div::after{
    content: '';
    position: absolute;
    top: -10px;
    left: 0;
    background: var(--text-default);
    width: var(--width);
    height: 2px;
    transition: all 0.2s ease;
}

.hamburger > div::after{
    top: 10px;
}

/* IF THE TOGGLER IS IN ITS CHECKED STATE, THEN SETTING THE BACKGROUND OF THE MIDDLE LAYER TO COMPLETE BLACK AND OPAQUE :  */

.toggler:checked + .hamburger > div{
    background: rgba(0,0,0,0);
}

.toggler:checked + .hamburger > div::before{
    top: 0;
    transform: rotate(45deg);
    background: var(--accent-strong-default);
}

/* AND ROTATING THE TOP AND BOTTOM LINES :  */

.toggler:checked + .hamburger > div::after{
    top: 0;
    transform: rotate(135deg);
    background: var(--accent-strong-default);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/nav_toggle/style/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;;AAGA;IACI;QACI,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;QACf,qCAAqC;QACrC,mCAAmC;QACnC,eAAe;IACnB;;IAEA,WAAW;IACX,8BAA8B;IAC9B,IAAI;;AAER;;AAEA,mFAAmF;AACnF,mFAAmF;;AAEnF;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uEAAuE;IACvE,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,MAAM;IACN,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,+BAA+B;IAC/B,WAAW;IACX,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;4EAC4E;;AAE5E;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA,4HAA4H;;AAE5H;IACI,yBAAyB;AAC7B;;AAEA;IACI,MAAM;IACN,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA,6CAA6C;;AAE7C;IACI,MAAM;IACN,yBAAyB;IACzB,wCAAwC;AAC5C","sourcesContent":[":host {\n    --width: 32px;\n    --height: 32px;\n    display: none;\n    /*border: 1px solid red;*/\n    width: var(--width);\n    height: var(--height);\n    /*cursor: pointer;*/\n    /*position: relative;*/\n}\n\n\n@media (max-width: 940px) {\n    :host {\n        display: inline-block;\n        /*background: red;*/\n        /*width: 26px;*/\n        margin-left: var(--custom-spacing-30);\n        /*margin-right: var(--spacing-15);*/\n        margin-right: 0;\n    }\n\n    /*button {*/\n    /*    border: 1px solid blue;*/\n    /*}*/\n\n}\n\n/*================================================================================*/\n/*================================================================================*/\n\nbutton {\n    width: var(--width);\n    height: 100%;\n    position: relative;\n    border: none;\n    background: none;\n}\n\n.toggler{\n    /* ALWAYS KEEPING THE TOGGLER OR THE CHECKBOX ON TOP OF EVERYTHING :  */\n    z-index:2;\n    height: var(--height);\n    width: var(--width);\n    position: absolute;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n    opacity: 0;\n}\n\n.hamburger{\n    position: absolute;\n\n    top: 0;\n    left: -4px;\n    height: var(--height);\n    width: var(--width);\n    /* FOR DISPLAYING EVERY ELEMENT IN THE CENTER : */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* CREATING THE MIDDLE LINE OF THE HAMBURGER : */\n.hamburger > div{\n    position: relative;\n    top: 0;\n    left: 4px;\n    background: var(--text-default);\n    height: 2px;\n    width: var(--width);\n    transition: all  0.2s ease;\n}\n\n/* CREATING THE TOP AND BOTTOM LINES :\nTOP AT -10PX ABOVE THE MIDDLE ONE AND BOTTOM ONE IS 10PX BELOW THE MIDDLE: */\n\n.hamburger > div::before,\n.hamburger > div::after{\n    content: '';\n    position: absolute;\n    top: -10px;\n    left: 0;\n    background: var(--text-default);\n    width: var(--width);\n    height: 2px;\n    transition: all 0.2s ease;\n}\n\n.hamburger > div::after{\n    top: 10px;\n}\n\n/* IF THE TOGGLER IS IN ITS CHECKED STATE, THEN SETTING THE BACKGROUND OF THE MIDDLE LAYER TO COMPLETE BLACK AND OPAQUE :  */\n\n.toggler:checked + .hamburger > div{\n    background: rgba(0,0,0,0);\n}\n\n.toggler:checked + .hamburger > div::before{\n    top: 0;\n    transform: rotate(45deg);\n    background: var(--accent-strong-default);\n}\n\n/* AND ROTATING THE TOP AND BOTTOM LINES :  */\n\n.toggler:checked + .hamburger > div::after{\n    top: 0;\n    transform: rotate(135deg);\n    background: var(--accent-strong-default);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
